import { del, get, post, put } from "../client";
import {
  GET_ALL_PRODUCTS,
  ADD_PRODUCT,
  EDIT_PRODUCT,
  DELETE_PRODUCT,
} from "../routes";

export default {
  get_all: async () => await get(GET_ALL_PRODUCTS),

  create: async (formData) => await post(ADD_PRODUCT, formData),

  edit: async (id, formData) => await put(EDIT_PRODUCT(id), formData),

  delete: async (id) => await del(DELETE_PRODUCT(id)),
};
